(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gco-cookies"] && !Shopify.designMode) return;
  try {
    
  class CookieBanner extends HTMLElement {
    #cookieName = 'tplCookieConsent';
    #cookieLifetime = 60;
    #boundKeydown = null;

    connectedCallback() {
      if (this.#getCookie(this.#cookieName)) return;

      this.hidden = false;
      this.#trapFocus();
      this.button?.addEventListener('click', this.#handleAccept.bind(this));
      this.#boundKeydown = this.#handleKeydown.bind(this);
      document.addEventListener('keydown', this.#boundKeydown);
    }

    disconnectedCallback() {
      if (this.#boundKeydown) {
        document.removeEventListener('keydown', this.#boundKeydown);
      }
    }

    get button() {
      return this.querySelector('[data-cookie-accept]');
    }

    #handleAccept() {
      const consent = {
        analytics: true,
        statistics: true,
        marketing: true,
        preferences: true,
        timestamp: new Date().toISOString(),
      };

      this.#setCookie('CookieConsent', JSON.stringify(consent), this.#cookieLifetime);
      this.#setCookie(this.#cookieName, '1', this.#cookieLifetime);

      window.dispatchEvent(
        new CustomEvent('cookieConsentUpdate', {
          detail: consent,
          bubbles: true,
        })
      );

      this.hidden = true;
    }

    #handleKeydown(event) {
      if (event.key === 'Escape' && !this.hidden) {
        this.#handleAccept();
      }
    }

    #trapFocus() {
      this.button?.focus();
    }

    #setCookie(name, value, days) {
      const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${encodeURIComponent(value)};path=/;expires=${expires.toUTCString()};SameSite=Lax`;
    }

    #getCookie(name) {
      const cookies = document.cookie.split('; ');
      for (const cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key === name) return decodeURIComponent(value);
      }
      return null;
    }
  }

  customElements.define('cookie-banner', CookieBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
